<div class="network-alert-wrapper {{isConnectedClass}}">
    <div class="network-alert {{networkStatus}}">
        <i class="icon-default"></i>
        <span>{{description}}</span>
        @if (!isConnected) {
        <div class="network-alert__loader"></div>
        }
    </div>
</div>